import { createSelector } from "reselect";

import { IStore } from "@app/redux/reducers";

const getPaymentFunction = (store: IStore) => store.payment.get("status");

export const getPaymentStatus = createSelector(getPaymentFunction, f => f);

const getPublicMessageFunction = (store: IStore) =>
  store.payment.get("publicMessage");

export const getPublicMessage = createSelector(
  getPublicMessageFunction,
  f => f,
);

const getReferenceNumberFunction = (store: IStore) =>
  store.payment.get("referenceNumber");

export const getReferenceNumber = createSelector(
  getReferenceNumberFunction,
  f => f,
);

const getOriginRouteFunction = (store: IStore) =>
  store.payment.get("originRoute");

export const getOriginRoute = createSelector(getOriginRouteFunction, f => f);

const getTargetRouteFunction = (store: IStore) =>
  store.payment.get("targetRoute");

export const getTargetRoute = createSelector(getTargetRouteFunction, f => f);
